// extracted by mini-css-extract-plugin
module.exports = {"video-story":"_2FI4-","no-top-padding":"M_XI2","story-body":"_1xRkl","story-content":"_36AM9","author-wrapper":"_1c9r8"};